import React from "react";
import Section1 from "../Services-page/Section1";
// import Section2 from "../portfolio/Section1";
import Section2 from "../Services-page/Section2";
import Section3 from "../Services-page/Section3";
import Section4 from "../Services-page/Section4";
import Section5 from "../Services-page/Section5";
import Section6 from "../Services-page/Section6";

const ServicesPage = () => {
  return (
    <div>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
    </div>
  );
};

export default ServicesPage;
